import type { DOMConversionOutput } from "lexical";
import type { UUID } from "../../../../../utils/uuid";
import type { PollNode } from "./poll-node";
import type { PollNodeMui } from "./poll-node-mui";
import type { PollNodeAnswerType } from "./types";

export function isPollElement(node: HTMLElement): boolean {
  return node.tagName === "DIV" && node.getAttribute("data-node-type") === "poll-node";
}

export function convertPollElement(
  domNode: Node,
  type: typeof PollNode | typeof PollNodeMui,
): DOMConversionOutput {
  if (domNode instanceof HTMLDivElement) {
    const pollId = domNode.getAttribute("data-poll-id");
    const answerType = domNode.getAttribute("data-poll-answer_type");
    if (!pollId || !answerType) {
      return { node: null };
    }

    return {
      node: new type(pollId as UUID, JSON.parse(answerType) as PollNodeAnswerType),
    };
  }

  return { node: null };
}
